module.exports = __webpack_public_path__ + "static/media/v28.427415c9.mp4";